import { useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/pages/home/components/Footer";

export default function GuiaCompleto() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://hoobuy.life';

  return (
    <main>
      <Navbar />

      {/* Article Hero */}
      <section className="relative w-full min-h-[60vh] flex items-center">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20editorial%20flat%20lay%20of%20a%20laptop%20displaying%20organized%20spreadsheet%20with%20product%20thumbnails%2C%20surrounded%20by%20fashion%20accessories%20like%20watch%20and%20sunglasses%20on%20rich%20wooden%20desk%2C%20soft%20morning%20light%20from%20left%20window%2C%20cozy%20workspace%20with%20notebook%20and%20coffee%2C%20editorial%20photography%2C%20warm%20terracotta%20and%20cream%20tones%2C%20clean%20composition&width=1920&height=900&seq=hoobuy-article-hero-v2-2026-k1m8&orientation=landscape"
            alt="Guia Completo da Hoobuy Spreadsheet 2026"
            title="Guia Completo Hoobuy Spreadsheet"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/35"></div>
        </div>

        <div className="relative z-10 w-full px-6 md:px-10 lg:px-16 pt-20">
          <div className="max-w-3xl">
            <span className="inline-block px-4 py-1.5 border border-white/40 rounded-full text-white text-xs md:text-sm font-medium tracking-wide mb-6">
              Guia 2026
            </span>
            <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl text-white font-medium leading-tight mb-6">
              O Guia Definitivo da Hoobuy Spreadsheet
            </h1>
            <p className="text-white/80 text-sm md:text-base max-w-lg leading-relaxed">
              Tudo o que precisa de saber sobre a Hoobuy Spreadsheet: como usar, onde encontrar os melhores links e como comprar com segurança a partir de Portugal.
            </p>
          </div>
        </div>
      </section>

      {/* Article Body */}
      <article className="relative bg-background-50 py-16 md:py-24 px-6 md:px-10">
        <div className="max-w-3xl mx-auto">
          {/* Intro */}
          <div className="prose-custom">
            <span className="inline-block px-3 py-1 text-xs font-medium text-primary-600 bg-primary-50 rounded-full mb-6">
              SEO 2026
            </span>

            <p className="text-foreground-700 text-base md:text-lg leading-relaxed mb-6">
              Se chegou até aqui, provavelmente já ouviu falar do Hoobuy e está à procura de uma forma mais organizada de encontrar produtos de qualidade. A <Link to="/" className="text-primary-600 hover:text-primary-700 font-medium underline cursor-pointer"><strong>Hoobuy Spreadsheet em Português 2026</strong></Link> foi criada exatamente para isso: reunir os melhores links verificados numa única planilha fácil de navegar. Neste guia completo, vamos explicar tudo o que precisa de saber para começar a usar a spreadsheet hoje mesmo.
            </p>

            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 font-medium mt-12 mb-5">
              O Que É a Hoobuy Spreadsheet?
            </h2>

            <p className="text-foreground-700 text-base leading-relaxed mb-4">
              A Hoobuy Spreadsheet é uma <strong className="text-foreground-900">planilha organizada com links verificados</strong> de produtos disponíveis na plataforma Hoobuy. Em vez de passar horas a procurar produtos manualmente, os utilizadores podem simplesmente navegar pelas categorias da spreadsheet e encontrar exatamente o que procuram.
            </p>

            <p className="text-foreground-700 text-base leading-relaxed mb-4">
              Cada link na nossa planilha passa por um processo de <strong className="text-foreground-900">verificação manual</strong> antes de ser adicionado. Isto significa que não encontrará links quebrados ou produtos de baixa qualidade. A nossa equipa dedica-se a manter a spreadsheet atualizada semanalmente, removendo links desatualizados e adicionando novos produtos populares.
            </p>

            <p className="text-foreground-700 text-base leading-relaxed mb-4">
              Atualmente, a nossa <strong className="text-foreground-900">planilha hoobuy</strong> conta com mais de <strong className="text-foreground-900">10.000 produtos</strong> organizados em 14 categorias distintas, desde tênis e roupa de rua até acessórios, bolsas e perfumes. É a maior coleção de links hoobuy verificados disponível em português.
            </p>

            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 font-medium mt-12 mb-5">
              Como Usar a Hoobuy Spreadsheet
            </h2>

            <p className="text-foreground-700 text-base leading-relaxed mb-4">
              Usar a nossa Hoobuy Spreadsheet é extremamente simples. Basta seguir estes passos:
            </p>

            <ol className="list-decimal list-inside space-y-3 text-foreground-700 text-base leading-relaxed mb-6 pl-2">
              <li><strong className="text-foreground-900">Escolha uma categoria</strong> — Navegue pelas 14 categorias disponíveis e encontre o tipo de produto que procura.</li>
              <li><strong className="text-foreground-900">Explore os links</strong> — Cada categoria contém dezenas de links verificados com informações sobre preço e qualidade.</li>
              <li><strong className="text-foreground-900">Copie o link</strong> — Quando encontrar um produto que lhe interessa, copie o link correspondente.</li>
              <li><strong className="text-foreground-900">Use o seu agente</strong> — Cole o link no seu agente de compras preferido para finalizar a encomenda.</li>
              <li><strong className="text-foreground-900">Acompanhe o envio</strong> — O seu agente tratará de todo o processo de compra e envio até Portugal.</li>
            </ol>

            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 font-medium mt-12 mb-5">
              Vantagens de Usar a Nossa Planilha
            </h2>

            <p className="text-foreground-700 text-base leading-relaxed mb-4">
              Existem várias razões pelas quais a nossa <strong className="text-foreground-900">Hoobuy Spreadsheet</strong> se destaca de outras alternativas disponíveis online:
            </p>

            <ul className="list-disc list-inside space-y-3 text-foreground-700 text-base leading-relaxed mb-6 pl-2">
              <li><strong className="text-foreground-900">Conteúdo em português</strong> — Todas as descrições e guias estão disponíveis em português, facilitando a compreensão para utilizadores em Portugal e no Brasil.</li>
              <li><strong className="text-foreground-900">Atualizações semanais</strong> — A spreadsheet é atualizada todas as semanas com novos produtos e links verificados.</li>
              <li><strong className="text-foreground-900">Links verificados manualmente</strong> — Cada link passa por uma revisão antes de ser incluído na planilha.</li>
              <li><strong className="text-foreground-900">Categorização intuitiva</strong> — Os produtos estão organizados em categorias fáceis de navegar.</li>
              <li><strong className="text-foreground-900">Comparações de preços</strong> — Incluímos tabelas comparativas para ajudar a encontrar o melhor custo-benefício.</li>
            </ul>

            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 font-medium mt-12 mb-5">
              Hoobuy é Seguro? Tudo o que Precisa de Saber
            </h2>

            <p className="text-foreground-700 text-base leading-relaxed mb-4">
              Esta é uma das perguntas mais frequentes que recebemos. A resposta curta é: <strong className="text-foreground-900">sim, o Hoobuy é seguro</strong>. No entanto, como em qualquer plataforma de marketplace, é importante tomar algumas precauções.
            </p>

            <p className="text-foreground-700 text-base leading-relaxed mb-4">
              O Hoobuy funciona como um intermediário entre compradores internacionais e vendedores chineses. A plataforma em si não vende produtos diretamente — ela facilita a conexão entre utilizadores e agentes de compras. Os <strong className="text-foreground-900">links hoobuy</strong> que fornecemos na nossa spreadsheet são todos de vendedores com bom histórico e avaliações positivas.
            </p>

            <p className="text-foreground-700 text-base leading-relaxed mb-4">
              Para uma experiência ainda mais segura, recomendamos sempre: verificar as avaliações do vendedor antes de comprar, utilizar agentes de compras com boa reputação, comparar preços entre diferentes vendedores e ler atentamente as políticas de devolução. Pode consultar mais informações na nossa <Link to="/" className="text-primary-600 hover:text-primary-700 font-medium underline cursor-pointer">página inicial</Link> onde abordamos estas questões em detalhe.
            </p>

            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 font-medium mt-12 mb-5">
              Comparação: Hoobuy vs Outras Plataformas
            </h2>

            <p className="text-foreground-700 text-base leading-relaxed mb-4">
              Muitos utilizadores perguntam-nos como o Hoobuy se compara a outras plataformas populares. Embora cada plataforma tenha as suas vantagens, o Hoobuy destaca-se pela:
            </p>

            <div className="bg-background-100 rounded-2xl p-6 md:p-8 my-8 overflow-x-auto">
              <table className="w-full text-left text-sm">
                <thead>
                  <tr className="border-b border-background-200">
                    <th className="pb-4 font-semibold text-foreground-800 pr-6">Característica</th>
                    <th className="pb-4 font-semibold text-foreground-800 pr-6">Hoobuy</th>
                    <th className="pb-4 font-semibold text-foreground-800 pr-6">Outras Plataformas</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-background-200/60">
                    <td className="py-3 text-foreground-900 font-medium pr-6">Variedade de Produtos</td>
                    <td className="py-3 text-accent-600 pr-6"><i className="ri-check-line"></i> Muito Alta</td>
                    <td className="py-3 text-foreground-600 pr-6">Média</td>
                  </tr>
                  <tr className="border-b border-background-200/60">
                    <td className="py-3 text-foreground-900 font-medium pr-6">Preços</td>
                    <td className="py-3 text-accent-600 pr-6"><i className="ri-check-line"></i> Competitivos</td>
                    <td className="py-3 text-foreground-600 pr-6">Variável</td>
                  </tr>
                  <tr className="border-b border-background-200/60">
                    <td className="py-3 text-foreground-900 font-medium pr-6">Links Verificados</td>
                    <td className="py-3 text-accent-600 pr-6"><i className="ri-check-line"></i> Sim</td>
                    <td className="py-3 text-foreground-600 pr-6">Nem sempre</td>
                  </tr>
                  <tr>
                    <td className="py-3 text-foreground-900 font-medium pr-6">Suporte em Português</td>
                    <td className="py-3 text-accent-600 pr-6"><i className="ri-check-line"></i> Sim</td>
                    <td className="py-3 text-foreground-600 pr-6">Raramente</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 font-medium mt-12 mb-5">
              Dicas para Comprar no Hoobuy a Partir de Portugal
            </h2>

            <p className="text-foreground-700 text-base leading-relaxed mb-4">
              Comprar no Hoobuy a partir de Portugal é um processo relativamente simples, mas existem algumas dicas que podem tornar a experiência ainda melhor:
            </p>

            <ul className="list-disc list-inside space-y-3 text-foreground-700 text-base leading-relaxed mb-6 pl-2">
              <li><strong className="text-foreground-900">Escolha o agente certo</strong> — Nem todos os agentes oferecem envio para Portugal. Verifique esta opção antes de se registar.</li>
              <li><strong className="text-foreground-900">Compare métodos de envio</strong> — Os preços de envio podem variar significativamente. Compare diferentes opções antes de decidir.</li>
              <li><strong className="text-foreground-900">Agrupe as compras</strong> — Comprar vários itens de uma vez e enviá-los juntos pode reduzir significativamente os custos de envio.</li>
              <li><strong className="text-foreground-900">Verifique as taxas alfandegárias</strong> — Esteja ciente das possíveis taxas de importação ao enviar para Portugal.</li>
              <li><strong className="text-foreground-900">Use a nossa spreadsheet</strong> — A <Link to="/" className="text-primary-600 hover:text-primary-700 font-medium underline cursor-pointer">Hoobuy Spreadsheet em português</Link> facilita a localização de produtos verificados.</li>
            </ul>

            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 font-medium mt-12 mb-5">
              Conclusão
            </h2>

            <p className="text-foreground-700 text-base leading-relaxed mb-4">
              A <strong className="text-foreground-900">Hoobuy Spreadsheet</strong> é a ferramenta ideal para quem quer poupar tempo e encontrar produtos de qualidade na plataforma Hoobuy. Com mais de 10.000 links verificados, 14 categorias organizadas e atualizações semanais, é a melhor opção disponível para compradores portugueses.
            </p>

            <p className="text-foreground-700 text-base leading-relaxed mb-4">
              Se ainda não começou a usar a nossa planilha, recomendamos que visite a nossa <Link to="/" className="text-primary-600 hover:text-primary-700 font-medium underline cursor-pointer">página inicial</Link> e explore as categorias disponíveis. Temos produtos para todos os gostos e orçamentos.
            </p>

            <p className="text-foreground-700 text-base leading-relaxed">
              Lembre-se: todos os links na nossa spreadsheet são verificados manualmente. Não vendemos produtos diretamente — o nosso objetivo é simplesmente ajudar utilizadores a encontrar os melhores vendedores e produtos no Hoobuy.
            </p>
          </div>

          {/* Internal Links */}
          <div className="mt-12 md:mt-16 p-6 md:p-8 bg-background-100 rounded-2xl">
            <h3 className="font-heading text-lg text-foreground-900 font-medium mb-4">Leia Também</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <Link
                to="/"
                className="flex items-center gap-2.5 text-sm text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer"
              >
                <i className="ri-home-line"></i>
                Voltar à Página Inicial
              </Link>
              <Link
                to="/#faq"
                className="flex items-center gap-2.5 text-sm text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer"
              >
                <i className="ri-question-line"></i>
                Perguntas Frequentes
              </Link>
            </div>
          </div>
        </div>
      </article>

      {/* Bottom CTA */}
      <section className="relative w-full py-24 md:py-36 px-6 md:px-10 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20flat%20lay%20of%20leather%20accessories%20including%20wallet%20watch%20and%20keychain%20on%20rich%20wooden%20desk%20with%20soft%20morning%20light%2C%20editorial%20product%20photography%2C%20elegant%20composition%2C%20warm%20cognac%20and%20amber%20tones%2C%20sophisticated%20masculine%20aesthetic&width=1920&height=800&seq=hoobuy-article-cta-v2-2026-g6z4&orientation=landscape"
            alt="Comece Agora com Hoobuy Spreadsheet"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/45 via-black/30 to-black/15"></div>
        </div>

        <div className="relative z-10 max-w-3xl">
          <h2 className="font-heading text-4xl md:text-5xl text-white font-semibold mb-6 leading-tight">
            Comece Agora
          </h2>
          <p className="text-white/80 text-sm md:text-base max-w-md mb-8 leading-relaxed">
            Explore a melhor Hoobuy Spreadsheet em português. Links verificados, produtos populares e compras seguras.
          </p>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-3 px-8 py-4 bg-white text-foreground-900 text-sm md:text-base font-semibold rounded-full hover:bg-white/95 transition-all whitespace-nowrap cursor-pointer group"
          >
            Aceder à Spreadsheet
            <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500 text-white group-hover:bg-primary-600 transition-colors">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </a>
        </div>
      </section>

      <Footer />

      {/* Schema.org Article structured data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            "headline": "O Guia Definitivo da Hoobuy Spreadsheet 2026",
            "description": "Tudo o que precisa de saber sobre a Hoobuy Spreadsheet: como usar, onde encontrar os melhores links e como comprar com segurança a partir de Portugal.",
            "author": {
              "@type": "Organization",
              "name": "Equipe Hoobuy Life"
            },
            "datePublished": "2026-01-15",
            "dateModified": "2026-06-26",
            "inLanguage": "pt-PT",
            "image": `${siteUrl}/favicon.jpeg`,
            "publisher": {
              "@type": "Organization",
              "name": "Hoobuy Life",
              "logo": {
                "@type": "ImageObject",
                "url": `${siteUrl}/favicon.jpeg`
              }
            },
            "isPartOf": {
              "@type": "WebSite",
              "name": "Hoobuy Life",
              "url": `${siteUrl}/`
            },
            "breadcrumb": {
              "@type": "BreadcrumbList",
              "itemListElement": [
                {
                  "@type": "ListItem",
                  "position": 1,
                  "name": "Início",
                  "item": `${siteUrl}/`
                },
                {
                  "@type": "ListItem",
                  "position": 2,
                  "name": "Guia Completo Hoobuy Spreadsheet",
                  "item": `${siteUrl}/artigo/guia-completo-hoobuy-spreadsheet`
                }
              ]
            }
          }),
        }}
      />
    </main>
  );
}